import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Field, reduxForm, Form} from 'redux-form'
import CustomSelect from "views/Components/CustomSelect.jsx"
import ValidatedCustomInput from "views/Components/ValidatedCustomInput.jsx"

import withStyles from "@material-ui/core/styles/withStyles";
import styles from "assets/jss/material-dashboard-pro-react/views/form";

import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
// core components
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";

import {required} from 'views/utils/validations'
import {
  transactionSave,
  transactionsFetch,
  transactionFetch,
} from 'actions/transactions'

import {
  danger,
  success,
} from 'actions/notification'

import {
  ibsFetch
} from 'actions/ibs'


class CreateEdit extends Component {
		componentDidMount(){
      if(this.props.ibs.length === 0) {
        this.props.ibsFetch()
      }
      
    }
		getInput(data) {
			return <Field
							name={data.key}
							placeholder={data.name}
							id={data.key}
              icon={data.icon}
              type={data.type}
							props={{
								name: data.key
							}}
							validate={data.required ? [required] : []}
							component={ValidatedCustomInput}
						/>
		}
		submit(values){
			this.props.save(values)
				.then(e=>{
					this.props.success(e.transactionId + ' Added',4)
					this.props.fetchAll()
					this.props.history.goBack()
				})
				.catch(e=>{this.props.danger(e+'',4);})
		}

    render(){
		const {classes, ibs, handleSubmit} = this.props
    return(
      <GridContainer justify="center">
        <GridItem xs={12} sm={8}>
          <Card>
            <CardBody>
              <Form onSubmit={handleSubmit(this.submit.bind(this))}>
                <GridContainer justify="center">

                  <GridItem xs={12} sm={12}>
                    <h4 className={classes.infoText}>
                      Adjustment
                    </h4>
                  </GridItem>
                  
                  <GridItem style={{marginTop:"25px"}} xs={12} sm={12} md={12} lg={10}>
                  
                    {this.getInput({key: 'amount', name: 'Amount', type: 'number', required:true})}
                    {this.getInput({key: 'approvingUserId', name: 'Approving User Id', type: 'number', required:true})}
                    
                    <FormControl
                      fullWidth
                      style={{paddingTop:'27px', marginBottom: '17px'}}
                    >
                      <TextField
                        id="changeStatusTime"
                        label="Change Status Time"
                        type="date"
                        onChange={(event) => this.change(event, "changeStatusTime")}
                        //value={registrationDate}
                        className={classes.textField}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </FormControl>

                    <FormControl
                      fullWidth
                      style={{paddingTop:'27px', marginBottom: '17px'}}
                    >
                      <TextField
                        id="creationTime"
                        label="Creation Time"
                        type="date"
                        onChange={(event) => this.change(event, "creationTime")}
                        //value={registrationDate}
                        className={classes.textField}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </FormControl>

                   

                    <Field
                      name="ibId"
                      options={ibs.map((i) => {return {value: i.ibId, label: i.name}})}
                      placeholder="IB *"
                      id="ibId"
                      props={{
                        name:"ibId"
                      }}
                      validate={[required]}
                      component={CustomSelect}
                    />
                  </GridItem>

                  <GridItem xs={12} sm={12} md={12} lg={10}>
                      <Button type="submit"  className={classes.submit} color="success">Submit</Button>
                  </GridItem>
                </GridContainer>
              </Form>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      )
  }
}

function mapStateToProps(state) {
	return {
		ibs: state.ibs.list,
	}
}

function mapDispatchToProps(dispatch) {
	return {
		fetch:(id)=>dispatch(transactionFetch(id)),
		fetchAll:() => dispatch(transactionsFetch()),
		save:(data)=>dispatch(transactionSave(data)),
		danger:(text,sec)=>dispatch(danger(text,sec)),
		success:(text,sec)=>dispatch(success(text,sec)),
		ibsFetch: () => dispatch(ibsFetch()),
	}
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(reduxForm({ form: 'createCreateEditForm' })(CreateEdit)))



// WEBPACK FOOTER //
// ./src/views/AdjustmentsReason/Form.jsx